module.exports = __webpack_public_path__ + "static/squirrels-of-central-park-preview-91993436eb8c631a4dcf2c8f83b68e32.gif";